import React from "react"

export default props => (
  <form className="simple_form" acceptCharset="UTF-8" method="post" {...props}>
    <input name="utf8" type="hidden" value="&#x2713;" /> {props.children}
  </form>
)
